import { render, staticRenderFns } from "./EventSelectionModalOdds.vue?vue&type=template&id=6afb3a0a"
import script from "./EventSelectionModalOdds.vue?vue&type=script&lang=js"
export * from "./EventSelectionModalOdds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports